import { useState } from "react";
import { Button, Input } from "reactstrap";

import { GeneratedText, ToolWrapper } from "./EmailGenerator";
import useCustomPrompt from "../../../../api/api-hooks/brie/useCustomPrompt";
import AppSpinner from "../../../../elements/AppSpinner";

interface Props {
  providedStateValue?: string;
  providedStateSetter?: React.Dispatch<React.SetStateAction<string>>;
  simplified?: boolean;
}

export default function CustomPrompt({
  providedStateValue,
  providedStateSetter,
  simplified,
}: Props) {
  const [generatedTextState, setGeneratedTextState] = useState("");
  const [description, setDescription] = useState("");
  const { generateText, generating } = useCustomPrompt();

  const generatedText = providedStateValue || generatedTextState;
  const setGeneratedText = providedStateSetter || setGeneratedTextState;

  const CustomPromptBody = (
    <>
      <p className="text-sm text-dark mb-1 font-weight-bold">Description</p>
      <Input
        type="textarea"
        rows={5}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Example: Draft a proposal outlining strategies to improve employee satisfaction and retention rates within our organization"
        disabled={generating}
      />
      <div className="d-flex justify-content-end mt-3">
        {generating ? (
          <AppSpinner size="xl" />
        ) : (
          <>
            <Button size="sm" outline onClick={restart}>
              Restart
            </Button>
            <Button
              size="sm"
              color="primary"
              onClick={onGenerate}
              disabled={!description}
            >
              Generate
            </Button>
          </>
        )}
      </div>
      {generatedText && (
        <GeneratedText title="Generated Text:" text={generatedText} />
      )}
    </>
  );

  return simplified ? (
    CustomPromptBody
  ) : (
    <ToolWrapper
      title="Custom Prompt"
      description="Input your own prompts to guide the AI in generating personalized content according to your specifications."
      icon="mail"
    >
      {CustomPromptBody}
    </ToolWrapper>
  );

  function onGenerate() {
    generateText({
      payload: { description },
      onSuccess: setGeneratedText,
    });
  }

  function restart() {
    setDescription("");
  }
}
